import { generatePath } from 'react-router-dom'
import { CompanyTag } from '@/components/ui/badge'
import { GridCellProps, GridColumnProps } from '@progress/kendo-react-grid'
import { IntroducingBrokerKey } from 'api/Trading-Accounts/Types/IntroducingBrokerDto'
import { Link } from 'components/Link'
import { formatLocalDateUTC } from 'utils/date'
import { links } from 'utils/featureToggles'

export interface GridColumn extends GridColumnProps {
  show: boolean
  width?: number
}

const introducingBrokerColumn: GridColumn[] = [
  {
    title: 'Name',
    field: IntroducingBrokerKey.name,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
              id: props.dataItem.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.name}
        </Link>
      </td>
    ),
    show: true,
    filter: 'text',
  },
  {
    title: 'Client',
    field: IntroducingBrokerKey.client, // CANNOT PROVIDE HERE FULL NAME TO EXPORT!
    cell: (props: GridCellProps) => (
      <td
        className='transaction-columns__content'
        style={{ color: 'var(--link)', textDecoration: 'underline' }}
      >
        <Link
          state={{ redirectTo: links.recordsIntroducingBrokers.url }}
          to={{
            pathname: generatePath(links.recordsClients.detailsUrl as string, {
              id: props.dataItem.client.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.client.name}
        </Link>
      </td>
    ),
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Country',
    field: IntroducingBrokerKey.country,
    show: true,
    filter: 'text',
  },
  {
    title: 'Profile',
    field: IntroducingBrokerKey.profile,
    cell: (props: GridCellProps) => (
      <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
        <Link
          to={{
            pathname: generatePath(links.brokerageIBProfiles.detailsUrl as string, {
              id: props.dataItem.profile.id,
              slug: 'details',
            }),
          }}
        >
          {props.dataItem.profile.name}
        </Link>
      </td>
    ),
    filterable: true,
    show: true,
    filter: 'text',
  },
  {
    title: 'Status',
    field: IntroducingBrokerKey.status,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Commission Status',
    field: IntroducingBrokerKey.commissionCalculationStatus,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Parent IB',
    field: IntroducingBrokerKey.parent,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.parent?.name) {
        return <td />
      }
      return (
        <td style={{ color: 'var(--link)', textDecoration: 'underline' }}>
          <Link
            to={{
              pathname: generatePath(links.recordsIntroducingBrokers.detailsUrl as string, {
                id: props.dataItem.parent.id,
                slug: 'details',
              }),
            }}
          >
            {props.dataItem.parent.name}
          </Link>
        </td>
      )
    },
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Parent Type',
    field: IntroducingBrokerKey.parentType,
    show: true,
    filterable: true,
    filter: 'text',
  },
  {
    title: 'Multi-level agreement',
    show: true,
    field: 'multiLevelAgreement',
    children: [
      {
        title: 'Registered At',
        field: IntroducingBrokerKey.multiLevelRegisteredAt,
        cell: (props: GridCellProps): JSX.Element => {
          if (!props?.dataItem?.multiLevelRegisteredAt) {
            return <td />
          }

          return (
            <td className='clients-table-columns__date'>
              {formatLocalDateUTC(props.dataItem.multiLevelRegisteredAt, true)}
            </td>
          )
        },
        filterable: true,
        filter: 'text',
      },
      {
        title: 'Commission Percentage',
        field: IntroducingBrokerKey.multiLevelPercentage,
        filterable: true,
        filter: 'text',
      },
    ],
  },
  {
    title: 'Registered At',
    field: IntroducingBrokerKey.registeredAt,
    cell: (props: GridCellProps) => (
      <td className='clients-table-columns__date'>
        {formatLocalDateUTC(props.dataItem.registeredAt, true)}
      </td>
    ),
    filterable: true,
    show: true,
    filter: 'text',
  },
  {
    title: 'Assignee',
    field: IntroducingBrokerKey.assignee,
    show: true,
    filterable: true,
    sortable: false,
    className: 'table-columns__content',
    filter: 'text',
  },
  {
    title: 'Entity',
    field: IntroducingBrokerKey.tickmillCompany,
    show: true,
    cell: (props: GridCellProps): JSX.Element => {
      if (!props.dataItem?.client?.tickmillCompany?.id) {
        return <td />
      }
      return (
        <td>
          <CompanyTag id={props.dataItem.client.tickmillCompany.id}>
            {props.dataItem.client.tickmillCompany.name}
          </CompanyTag>
        </td>
      )
    },
    filter: 'text',
    width: 80,
    minResizableWidth: 80,
  },
]

export default introducingBrokerColumn
